import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { ProfileService } from '../../_services/profile.service';

@Component({
  selector: 'app-password-reset-request',
  templateUrl: './password-reset-request.component.html',
  styleUrls: ['./password-reset-request.component.css'],
})
export class PasswordResetRequestComponent extends Form implements OnInit {
  protected email: string;
  protected send: boolean;
  protected loading: boolean;

  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    protected route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.form = fb.group({
      email: [''],
    });
  }

  ngOnInit() {
    this.setFormMode('create');
  }

  protected onSubmit() {
    if (!this.loading) {
      this.loading = true;
      this.profileService.resetPassword({ email: this.email }).subscribe(
        (response) => {
          this.send = true;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.handleError(error);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/password/password-reset-request/password-reset-request.component.ts